export class AzureSqlRestoreTargetServers {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "servers",
            "baseName": "servers",
            "type": "Array<AzureSqlServer>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlRestoreTargetServers.attributeTypeMap;
    }
    constructor() {
    }
}
